import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { faShieldCheck } from '@fortawesome/pro-solid-svg-icons/faShieldCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { WidgetCard } from 'us-react-components/dist/WidgetCard/WidgetCard';
import { Routes } from '../../../../../Routes';
import { Button, ButtonType } from '../../../../Button';

export const SafetyTrust = (): JSX.Element => {
  const { t } = useTranslation();

  const handleClick = (): void => {
    const route = generatePath(Routes.public.trust);
    window.open(route, '_blank', 'noreferrer')
  }

  return (
    <WidgetCard
      iconName={faShieldCheck}
      title={t('dashboard.widgets.safety.title')}
      description={t('dashboard.widgets.safety.description')}
      moreDescription={t('dashboard.widgets.safety.expandedDesciption')}
      classes='bg-neutral-100 border-transparent md:w-96 md:min-h-44'
      hasButton
      buttonComponent={<Button
          buttonType={ButtonType.secondary}
          onClick={handleClick}>{t('dashboard.widgets.safety.learnMore')}
          <FontAwesomeIcon icon={faAngleRight} className='pl-2 m-[-1px]' />
        </Button>
      }
    />
  );
};
